export default "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAACCAYAAAAw9X6zAAAAAXNSR0IArs4c6QAAABRJREFUKFNj/P///3+GQQQYB5uDALR3B/tzIOinAAAAAElFTkSuQmCC"